import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  totalClients: "Total Clients",
  newThisMonth: "this month",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    totalClients: "Nombre total de clients",
    newThisMonth: "ce mois-ci",
  },
  es_ES: {
    totalClients: "Total de clientes",
    newThisMonth: "este mes",
  },
  pt_BR: {
    totalClients: "Total de clientes",
    newThisMonth: "este mês",
  },
  de_DE: {
    totalClients: "Kunden gesamt",
    newThisMonth: "diesen Monat",
  },
  it_IT: {
    totalClients: "Totale clienti",
    newThisMonth: "questo mese",
  },
  ar: {
    totalClients: "إجمالي العملاء",
    newThisMonth: "هذا الشهر",
  },
  ja_JP: {
    totalClients: "顧客総数",
    newThisMonth: "今月",
  },
  hi_IN: {
    totalClients: "कुल क्लाइंट",
    newThisMonth: "इस माह",
  },
  zh_CN: {
    totalClients: "客户总数",
    newThisMonth: "本月",
  },
  zh_TW: {
    totalClients: "客戶總數",
    newThisMonth: "本月",
  },
  nl_NL: {
    totalClients: "Totaal aantal klanten",
    newThisMonth: "deze maand",
  },
  nb_NO: {
    totalClients: "Totalt antall kunder",
    newThisMonth: "denne måneden",
  },
  sv_SE: {
    totalClients: "Totalt antal kunder",
    newThisMonth: "denna månad",
  },
  fi_FI: {
    totalClients: "Asiakkaita yhteensä",
    newThisMonth: "tässä kuussa",
  },
  da_DK: {
    totalClients: "Kunder i alt",
    newThisMonth: "denne måned",
  },
  is_IS: {
    totalClients: "Viðskiptavinir alls",
    newThisMonth: "í þessum mánuði",
  },
};
